export default {
  init (vue) {
    return {
      getJssdkSign (params) {
        return vue.$http({
          method: 'GET',
          url: `/wxmp/user/getJssdkSign`,
          params: params
        })
      },
      getShareId(data) {
        return vue.$http({
          method: 'POST',
          url: `/wxmp/user/getOpenId`,
          data: data
        })
      },
      login(data) {
        return vue.$http({
          method: 'POST',
          url: `/shop/payact/login`,
          data: {
            ...data
          }
        })
      },
      getUserInfo(params) {
        return vue.$http({
          method: 'GET',
          url: `/shop/payact/getUserInfo`,
          params: params
        })
      },
      getUserTakeList(params) {
        return vue.$http({
          method: 'GET',
          url: `/shop/payact/getUserTakeList`,
          params: params
        })
      },
      loginByGoodsCode(data) {
        return vue.$http({
          method: 'POST',
          url: `/wxmp/user/loginByGoodsCode`,
          data: {
            ...data
          }
        })
      },
      /**
       * 通过code获取token(openid)
       * @param {code: code} data 
       */
      getWxUserToken(data) {
        return vue.$http({
          method: 'POST',
          url: `/wxmp/user/getUserOpenId`,
          data: {
            ...data
          }
        })
      },
    }
  }
}